module.exports = __webpack_public_path__ + "e69f74c8.svg";